import React from 'react'
import { Button, Image } from 'semantic-ui-react'
import finish from '../../../../assets/svg/wizard_finish_step.svg'
import WizardComponent from '../../../../components/Modal/WizardComponent'
import { IWizardProject } from '../../types/wizardData'

interface Props {
  open: boolean;
  data: IWizardProject;
  wizardFinishedSteps: number[];
  setWizardFinishedSteps: (steps: number[]) => void;
  setWizardStep: (step: string) => void;
  setProjectWizardData: (data: IWizardProject) => void;
  onClose: () => void;
}

const WizardFinishStep = (props: Props): JSX.Element => {
  const renderContent = () => {
    return (
      <Image style={{ margin: 'auto' }} src={finish} />
    )
  }

  const renderFooter = () => {
    return (
      <div>
        <Button
          primary={true}
          size='small'
          onClick={props.onClose}
          content='Start now'
          style={{ width: '8.57rem', height: '2.14rem', borderRadius: '.34rem', padding: 0 }}
        />
      </div>
    )
  }

  const _steps = [
    { key: 1, name: 'step-one' },
    { key: 2, name: 'step-two' },
    { key: 3, name: 'step-three' },
    { key: 4, name: 'step-four' },
    { key: 5, name: 'step-five' },
    { key: 6, name: 'step-six' }
  ]
  return (
    <WizardComponent
      open={props.open}
      close={props.onClose}
      content={renderContent()}
      headerContent='Project successfully created!'
      headerColor='#232C58'
      steps={props.data.type === 'service_provider' ? 6 : 5}
      width={'650px'}
      finishedSteps={props.wizardFinishedSteps}
      minHeight='16rem'
      hidePopup={true}
      setWizardStep={props.setWizardStep}
      setProjectWizardData={props.setProjectWizardData}
      data={props.data}
      stepStringList={_steps}
      headerContentFontSize='31.5px'
      footer={renderFooter()}
    />
  )
}

export default WizardFinishStep
